// Keeps the browser's <meta name="theme-color"> (it tints Android's status bar) matching the phone top bars, which are the
// page background (--app-bg) deepened by this much (see .mobile-chrome in index.css).
const TOP_BAR_DARKEN = 0.18;

/** The top bar colour for a page background given as `rgb(r, g, b)` / `rgba(...)`; null if it can't be read. */
export function topBarColor(pageBackground: string): string | null {
  const m = pageBackground.match(/rgba?\(\s*(\d+)[,\s]+(\d+)[,\s]+(\d+)/);
  if (!m) return null;
  return '#' + [m[1], m[2], m[3]].map((n) => Math.round(Number(n) * (1 - TOP_BAR_DARKEN)).toString(16).padStart(2, '0')).join('');
}

function apply() {
  const meta = document.querySelector('meta[name="theme-color"]');
  const color = topBarColor(getComputedStyle(document.body).backgroundColor);
  if (meta && color) meta.setAttribute('content', color);
}

/** Sets the theme colour now and again whenever the background or theme changes. */
export function startThemeColorSync() {
  apply();
  new MutationObserver(apply).observe(document.documentElement, { attributes: true, attributeFilter: ['data-bg', 'data-theme', 'style'] });
}
